function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PulseLoader } from 'react-spinners';
import classnames from 'classnames';
import Link from '../Link/Link';
var LinkButton = function(_param) {
    var children = _param.children, className = _param.className, disabled = _param.disabled, loading = _param.loading, tmp = _param.tooltipProps, _ref = tmp === void 0 ? {} : tmp, _ref_placement = _ref.placement, placement = _ref_placement === void 0 ? 'bottom' : _ref_placement, _ref_text = _ref.text, text = _ref_text === void 0 ? '' : _ref_text, rest = _object_without_properties(_param, [
        "children",
        "className",
        "disabled",
        "loading",
        "tooltipProps"
    ]);
    return /*#__PURE__*/ React.createElement(OverlayTrigger, {
        placement: placement,
        delay: {
            show: 250
        },
        overlay: /*#__PURE__*/ React.createElement(Tooltip, null, text)
    }, /*#__PURE__*/ React.createElement(Link, _object_spread_props(_object_spread({
        className: classnames(className, {
            disabled: disabled
        })
    }, rest), {
        to: (rest === null || rest === void 0 ? void 0 : rest.to) || ''
    }), loading ? /*#__PURE__*/ React.createElement(PulseLoader, {
        color: "#fff",
        size: 12
    }) : children));
};
export default LinkButton;
